import type { ElementType } from 'react';
import { styled } from '@classify/react-core-components/styles';

const Root = styled('div')(({ theme: { palette } }) => ({
  border: `1px solid ${palette.layout.surface.border}`,
  display: 'inline-flex',
  width: 40,
  height: 40,
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
}));

const UvpIcon = ({ icon: Icon }: { icon: ElementType }) => (
  <Root>
    <Icon />
  </Root>
);

export default UvpIcon;
